/**
 * 가상번호 연동 샘플 (/adm/virtual-number/sample) — 통신사(다우) API 직접 호출 테스트(할당·매핑·취소·목록)
 * ($j.Pages.Admin.VirtualNumberSample / body data-page-name="VirtualNumberSample")
 */
export default class VirtualNumberSample {
    initialize() { initialize(); }
}

function initialize() {
    $('#cm_map_btn').on('click', () => callVirtualNumber('map'));
    $('#cm_cancel_btn').on('click', () => callVirtualNumber('cancel'));
    $('#cm_alloc_btn').on('click', allocate);
    $('#cm_list_btn').on('click', loadList);
    // 목록 행 클릭 → 위 입력칸에 vn/rn 채움
    $('#cm_list_body').on('click', 'tr[data-vn]', function () {
        $('#cm_vn').val($(this).data('vn'));
        const rn = String($(this).data('rn') || '');
        if (rn) $('#cm_rn').val(rn);
    });
}

function allocate() {
    const rn   = String($('#cm_rn').val()).trim();
    const brNm = String($('#cm_brnm').val()).trim();

    if (rn.replace(/\D/g, '').length < 9) {
        $j.Ui.Dialog.open({tone: 'warn', title: '실번호를 확인해주세요.'});
        return;
    }

    const $btn = $('#cm_alloc_btn').prop('disabled', true);
    const orig = $btn.html();
    $btn.html('<i class="fa fa-spinner fa-spin"></i> 연결 중...');

    $.post('/adm/ajax/virtual-number/allocate', {rn, brNm}, function (res) {
        if (res.virtual_number) $('#cm_vn').val(res.virtual_number);   // 자동 선택된 가상번호를 입력칸에 반영
        renderResult(res);
        if (res.result) loadList();             // 풀 상태 갱신
    }, 'json').fail(function () {
        $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
    }).always(function () {
        $btn.prop('disabled', false).html(orig);
    });
}

function loadList() {
    const selGbn = $('#cm_selgbn').val();
    const $btn = $('#cm_list_btn').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i>');

    $.post('/adm/ajax/virtual-number/list', {selGbn}, function (res) {
        if (!res.result) {
            $('#cm_list_summary').text(res.resMsg || res.message || '조회 실패').css('color', 'var(--adm-c-dc3545, #dc3545)');
            renderList([]);
            return;
        }
        $('#cm_list_summary').css('color', '')
            .text(`총 ${res.totCnt}건 중 ${res.selCnt}건 표시 — 행 클릭 시 가상번호 입력칸에 채워집니다.`);
        renderList(res.vnList || []);
    }, 'json').fail(function () {
        $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
    }).always(function () {
        $btn.prop('disabled', false).html('<i class="fa fa-search"></i> 조회');
    });
}

// stat 코드 — 매뉴얼에 코드표가 없어 실제 응답 관측값 기준으로 라벨링 (3=사용중, 9=미사용).
// 그 외 값은 코드 그대로 노출.
const STAT_LABEL = {'3': '사용중', '9': '미사용'};

function renderList(list) {
    const $body = $('#cm_list_body').empty();
    if (!list.length) {
        $body.html('<tr><td colspan="5" class="text-center text-muted">데이터가 없습니다.</td></tr>');
        return;
    }
    list.forEach(function (r) {
        const vn = r.vn || '';
        const rn = r.rn || '';
        const stat = STAT_LABEL[String(r.stat)] || ('코드' + (r.stat ?? '-'));
        const $tr = $('<tr>').css('cursor', 'pointer')
            .attr('data-vn', vn).attr('data-rn', rn)
            .html(
                `<td class="text-center">${escapeHtml(vn)}</td>` +
                `<td class="text-center">${escapeHtml(rn) || '<span class="text-muted">-</span>'}</td>` +
                `<td class="text-center">${escapeHtml(stat)}</td>` +
                `<td>${escapeHtml(r.brNm || '')}</td>` +
                `<td class="text-center">${escapeHtml(r.linkDt || '')}</td>`
            );
        $body.append($tr);
    });
}

function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}

function callVirtualNumber(action) {
    const vn   = String($('#cm_vn').val()).trim();
    const rn   = String($('#cm_rn').val()).trim();
    const brNm = String($('#cm_brnm').val()).trim();

    if (vn.replace(/\D/g, '').length < 9) {
        $j.Ui.Dialog.open({tone: 'warn', title: '가상번호를 확인해주세요.'});
        return;
    }
    if (action === 'map' && rn.replace(/\D/g, '').length < 9) {
        $j.Ui.Dialog.open({tone: 'warn', title: '실번호를 확인해주세요.'});
        return;
    }

    const $btn = action === 'map' ? $('#cm_map_btn') : $('#cm_cancel_btn');
    const origHtml = $btn.html();
    $('#cm_map_btn, #cm_cancel_btn').prop('disabled', true);
    $btn.html('<i class="fa fa-spinner fa-spin"></i> 호출 중...');

    $.post('/adm/ajax/virtual-number/' + action, {vn, rn, brNm}, function (res) {
        renderResult(res);
    }, 'json').fail(function () {
        $j.Ui.Dialog.open({tone: 'danger', title: '서버 오류'});
    }).always(function () {
        $('#cm_map_btn, #cm_cancel_btn').prop('disabled', false);
        $btn.html(origHtml);
    });
}

function renderResult(res) {
    const ok = !!res.result;
    const $badge = $('#cm_rescd_badge');

    $badge.text(res.resCd || (ok ? 'SUCCESS' : 'FAIL'))
          .removeClass('bg-success bg-danger')
          .addClass(ok ? 'bg-success' : 'bg-danger');
    $('#cm_resmsg').text(res.resMsg || res.message || '');
    $('#cm_raw').text(JSON.stringify(res.raw ?? res, null, 2));
    $('#cm_result_card').removeClass('vs-off');   // .card(flex) 라 show() 대신 숨김 클래스를 뗀다

    // 성공은 스스로 사라지던 알림이라 토스트, 실패는 눌러서 닫는 다이얼로그
    const msg = res.resMsg || res.message || (ok ? 'SUCCESS' : 'FAIL');
    if (ok) $j.Ui.Toast.show(msg, {type: 'success'});
    else $j.Ui.Dialog.open({tone: 'danger', title: '실패', desc: msg});
}
